import * as msal from '@azure/msal-browser'
import appConfig from "./../config/app"

let msalApp

export default {
  async configure(clientId, enableDummyUser = false) {
    if (msalApp) return

    if (!clientId && enableDummyUser) {
      const dummyUser = {
        accountIdentifier: 'demo-id',
        username: 'demo@example.net',
        name: 'Demo User',
        idTokenClaims: { tid: 'fake-tenant' }
      }

      msalApp = {
        config: { auth: { clientId: null } },
        loginPopup: () => {
          localStorage.setItem('dummyAccount', JSON.stringify(dummyUser))
          return Promise.resolve()
        },
        logout: () => {
          localStorage.removeItem('dummyAccount')
          window.location.href = '/'
          return Promise.resolve()
        },
        acquireTokenSilent: () => Promise.resolve({ accessToken: '1234567890' }),
        getAllAccounts: () => [JSON.parse(localStorage.getItem('dummyAccount'))],
        removeAccount: () => Promise.resolve()
      }

      return
    }

    if (!clientId) return

    const config = {
      auth: {
        clientId,
        redirectUri: appConfig.AZURE_OAUTH_REDIRECT_URI,
        authority: 'https://login.microsoftonline.com/common'
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: /MSIE|Trident/.test(navigator.userAgent)
      }
    }

    msalApp = new msal.PublicClientApplication(config)
  },

  clientId() {
    return msalApp?.config?.auth?.clientId || null
  },

  async login(scopes = ['user.read', 'openid', 'profile', 'email', 'contacts.read']) {
    if (!msalApp) return

    this.clearLocal()
    const accounts = msalApp.getAllAccounts()
    for (const account of accounts) {
      await msalApp.removeAccount(account)
    }

    try {
      await msalApp.loginPopup({
        scopes,
        prompt: 'select_account'
      })
    } catch (e) {
      await msalApp.loginRedirect({
        scopes,
        prompt: 'select_account'
      })
    }
  },

  async acquireToken(scopes = ['user.read', 'contacts.read']) {
    if (!msalApp) return null

    const account = this.user()
    const accessTokenRequest = {
      scopes,
      account
    }

    let tokenResp

    try {
      tokenResp = await msalApp.acquireTokenSilent(accessTokenRequest)
    } catch (err) {
      tokenResp = await msalApp.acquireTokenPopup(accessTokenRequest)
    }

    if (!tokenResp.accessToken) {
      throw new Error("No accessToken returned")
    }

    return tokenResp.accessToken
  },

  async logout() {
    if (msalApp?.logoutPopup) {
      const accounts = msalApp.getAllAccounts()
      for (const account of accounts) {
        await msalApp.removeAccount(account)
      }
      this.clearLocal()
      await msalApp.logoutPopup()
    }
  },

  async switchAccount(scopes = ['user.read', 'openid', 'profile', 'email', 'contacts.read']) {
    await this.logout()
    await this.login(scopes)
  },

  user() {
    if (!msalApp || typeof msalApp.getAllAccounts !== 'function') return null
    const accounts = msalApp.getAllAccounts()
    return accounts?.[0] || null
  },

  clearLocal() {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith("msal.") || key.includes("msal")) {
        localStorage.removeItem(key)
      }
    })

    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith("msal.") || key.includes("msal")) {
        sessionStorage.removeItem(key)
      }
    })
  },

  isConfigured() {
    return !!msalApp
  }
}
